import React from 'react'
import Navbar from '../components/Navbar'
import SocietyRoleInfo from '../components/homepage/SocietyRoleInfo'
import WhyContent from '../components/homepage/WhyContent'
import PatreonInfo from '../components/homepage/PatreonInfo'
import MailForm from '../components/homepage/MailForm'
import Faqs from '../components/homepage/Faqs'
import HeroBox from '../components/homepage/HeroBox'
import ConnectAnnouncement from '../components/ConnectAnnouncement'
import Flagship from '../components/Flagship'
import FooterSection from '../components/FooterSection'
import patreonImage from '../assets/images/chief_patreon.jpg'
import { styled } from 'styled-components'
import useScrollBarPosition from '../hooks/useScrollBarPosition'
import BackToTop from '../components/BackToTop'
import heroImage1 from "../assets/images/iast_primus.jpg"
import heroImage2 from '../assets/images/acrp_factory.jpg'
import heroImage3 from '../assets/images/hero.jpg'
import heroImage4 from '../assets/images/happyblack.jpg'


const Homepage = () => {
  const slideShow = [heroImage1, heroImage2, heroImage3, heroImage4];
  const scrollPosition = useScrollBarPosition();
  
  return (
    <Wrapper className='wrapper'>
        <HeroBox imagesrc={slideShow}/>
        <SocietyRoleInfo />
        <PatreonInfo imagesrc={patreonImage}/>
        <WhyContent />
        <ConnectAnnouncement />
        <MailForm />
        <Faqs />
        <Flagship />
        <FooterSection />
        {
            (scrollPosition > 95) && <BackToTop />
        }
    </Wrapper>
  )
}

const Wrapper = styled.div`
`;

export default Homepage